import { Highlight } from "prism-react-renderer";
import { themes } from "prism-react-renderer";

const highlight = ( code, language ) => (
  <Highlight code={code} language={language} theme={themes.nightOwl}>
    {({ tokens, getLineProps, getTokenProps }) => (
      <>
        {tokens.map((line, i) => (
          <div key={i} {...getLineProps({ line, key: i })}>
            {line.map((token, key) => (
              <span key={key} {...getTokenProps({ token, key })} />
            ))}
          </div>
        ))}
      </>
    )}
  </Highlight>
);

export default highlight;
